import React from 'react'

import Login from '../login'

function OAuthLogin() {
  return <Login isOAuth={true} />
}

export default OAuthLogin
